<template>
  <div>
    <ca-row>
      <ca-col size="6">
        <ca-field label="Data de admissão">
          <ca-date-input v-model="contractInfo.admissionDate" required>
          </ca-date-input>
        </ca-field>
      </ca-col>

      <ca-col :size="!isDeterminedWorkTime ? 6 : 3">
        <ca-field label="Tipo de contrato de trabalho">
          <ca-select
            v-model="contractInfo.contractType.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="contractType in misc.contractTypes"
              :key="contractType.name"
              :value="contractType.name">
              {{ contractType.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>

      <ca-col v-if="isDeterminedWorkTime" size="3">
        <ca-field label="Data do término do contrato">
          <ca-date-input v-model="contractInfo.contractEndDate" required></ca-date-input>
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row v-if="isExperienceWorkTime">
      <ca-col size="3">
        <ca-field label="Qtd. de dias Experiência">
          <ca-input
            v-model="contractInfo.contractDaysExperience"
            type="number"
            mask-pattern="99"
            required
            @blur="onExperienceDaysChange"></ca-input>
        </ca-field>
      </ca-col>

      <ca-col size="3">
        <ca-field label="Qtd. de dias Prorrogação">
          <ca-input
            v-model="contractInfo.contractExtensionDays"
            type="number"
            mask-pattern="99"
            required></ca-input>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field label="Data do término do contrato">
          <ca-date-input v-model="contractInfo.contractEndDate" required></ca-date-input>
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="6">
        <ca-field label="Tipo de admissão">
          <ca-select
            v-model="contractInfo.admissionType.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="admissionType in misc.admissionTypes"
              :key="admissionType.name"
              :value="admissionType.name">
              {{ admissionType.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field label="Indicativo de admissão">
          <ca-select
            v-model="contractInfo.admissionIndicator.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="admissionCallsign in misc.admissionCallsigns"
              :key="admissionCallsign.name"
              :value="admissionCallsign.name">
              {{ admissionCallsign.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="6">
        <ca-field label="Unidade de salário">
          <ca-select
            v-model="contractInfo.salaryUnit.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="unidade in misc.salaryUnits"
              :key="unidade.name"
              :value="unidade.name">
              {{ unidade.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field :label="salaryUnitLabel">
          <ca-input-currency
            v-model="contractInfo.salary"
            :disabled="shouldDisableSalary"
            required
            maxlength="10" />
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="3">
        <ca-field label="Calcular Contribuição Sindical">
          <ca-checkbox v-model="contractInfo.unionContribution" label="Sim"></ca-checkbox>
        </ca-field>
      </ca-col>

      <ca-col size="3">
        <ca-field label="Calcular DSR">
          <ca-checkbox v-model="contractInfo.dsr" label="Sim"></ca-checkbox>
        </ca-field>
      </ca-col>

      <ca-col size="3">
        <ca-field label="Recebe FGTS">
          <ca-checkbox v-model="contractInfo.fgts" label="Sim"></ca-checkbox>
        </ca-field>
      </ca-col>

      <ca-col size="3">
        <ca-field label="Trabalho Temporário">
          <ca-checkbox
            v-model="contractInfo.temporary"
            label="Sim"
            @change="refreshForm"></ca-checkbox>
        </ca-field>
      </ca-col>
    </ca-row>

    <template v-if="contractInfo.temporary">
      <ca-row>
        <ca-col size="4">
          <ca-field label="Hipótese Legal para Contratação">
            <ca-select
              v-model="contractInfo.temporaryLegalType.name"
              :on-change="refreshForm">
              <ca-option
                v-for="value in misc.legalHyphotesesTypes"
                :key="value.name"
                :value="value.name">
                {{ value.description }}
              </ca-option>
            </ca-select>
          </ca-field>
        </ca-col>

        <ca-col size="4">
          <ca-field label="CPF do Trabalhador Substituído">
            <ca-cpf-input v-model="contractInfo.temporaryCpfReplaced" maxlength="14"></ca-cpf-input>
          </ca-field>
        </ca-col>

        <ca-col size="4">
          <ca-field label="Tipo de Inclusão de Contrato">
            <ca-select
              v-model="contractInfo.temporaryInclusion.name"
              :on-change="refreshForm">
              <ca-option
                v-for="value in misc.temporaryInclusion"
                :key="value.name"
                :value="value.name">
                {{ value.description }}
              </ca-option>
            </ca-select>
          </ca-field>
        </ca-col>
      </ca-row>

      <ca-row>
        <ca-col>
          <ca-field label="Justificação da Hipótese Legal">
            <ca-textarea
              v-model="contractInfo.temporaryJustification"
              :required="contractInfo.temporary"></ca-textarea>
          </ca-field>
        </ca-col>
      </ca-row>
    </template>
  </div>
</template>

<script>
import { SALARY_UNITY_VALUE_LABEL } from '../../workerConstants';
import { getExperienceDate } from '../../workersService';

export default {
  name: 'WorkerContractInfoForm',
  props: {
    contractInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    misc() {
      return this.$store.state.misc;
    },
    isDeterminedWorkTime() {
      return this.contractInfo.contractType.name === 'D';
    },
    isExperienceWorkTime() {
      return this.contractInfo.contractType.name === 'E';
    },
    salaryUnitLabel() {
      return SALARY_UNITY_VALUE_LABEL[this.contractInfo.salaryUnit.name];
    },
    shouldDisableSalary() {
      return !this.contractInfo.canChangeSalary;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      this.$store.dispatch('misc/getSalaryUnits');
      this.$store.dispatch('misc/getContractTypes');
      this.$store.dispatch('misc/getAdmissionTypes');
      this.$store.dispatch('misc/getAdmissionCallsigns');
      this.$store.dispatch('misc/getLegalHyphotesesTypes');
      this.$store.dispatch('misc/getTemporaryInclusion');
    },
    onExperienceDaysChange() {
      getExperienceDate(this.contractInfo.admissionDate, this.contractInfo.contractDaysExperience)
        .then(response => {
          this.contractInfo.contractExtensionDays = response.extensionQuantityDays;
          this.contractInfo.contractEndDate = response.endDate;
          this.$emit('refresh-form');
        });
    },
    refreshForm() {
      this.$emit('refresh-form');
    },
  },
};
</script>
